import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { resetAll } from "./actions/resetAll"

const initialState = {}

export const telaOrcamentoAlteradaNaoSalvaSlice = createSlice({
    name: "telaOrcamentoAlteradaNaoSalva",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        gravarTelasAlteradasNaoSalva: (telas, action: PayloadAction<string>) => {
            const nomeTela = action.payload
            telas[nomeTela] = true

            return telas
        },
        gravarTelasAlteradasSalva: (telas, action: PayloadAction<string>) => {
            if (action.payload === "") {
                return {}
            }
            
            const nomeTela = action.payload
            delete telas[nomeTela]

            return telas
        },
    }
})

export const {
    gravarTelasAlteradasNaoSalva: gravarTelasAlteradasNaoSalvaAction,
    gravarTelasAlteradasSalva: gravarTelasAlteradasSalvaAction
} = telaOrcamentoAlteradaNaoSalvaSlice.actions

export default telaOrcamentoAlteradaNaoSalvaSlice.reducer
